import { useClass } from '@/hooks/useClass'

const variantDirection = {
  top: 'bottom-0 bg-gradient-to-t',
  bottom: 'top-0 bg-gradient-to-b',
}

type BlurProps = React.ComponentProps<'div'> & {
  h: `h-[${number}px]`
  direction: keyof typeof variantDirection
}

export const Blur = ({ h, direction, className, ...props }: BlurProps) => {
  const blurClass = useClass(
    `absolute w-full from-black`,
    h,
    variantDirection[direction],
    className
  )

  return <div className={blurClass} {...props} />
}
